"use client";

import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/utils/supabase/client';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Plus, Move } from 'lucide-react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

interface Task {
  id: string;
  title: string;
  description: string;
  status: 'todo' | 'in_progress' | 'done';
  index: number;
}

interface KanbanBoardProps {
  projectId?: string;
}

const KanbanBoard: React.FC<KanbanBoardProps> = ({ projectId }: KanbanBoardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Kanban Board (Coming Soon)</CardTitle>
      </CardHeader>
      <CardContent>
        <p>This feature is under development. Stay tuned!</p>
      </CardContent>
    </Card>
  );
};

export { KanbanBoard };